import React from 'react';

import { TimelineConnector, TimelineSeparator } from '@mui/lab';

export default function SectionSeparator() {
  return (
    <TimelineSeparator>
      <TimelineConnector sx={{ height: 24, width: 2, bgcolor: 'cadet.300' }} />
    </TimelineSeparator>
  );
}
